import { Document, Font, Page, Text, StyleSheet } from "@react-pdf/renderer";

import { HTMLRenderer } from "./HTMLRenderer";
import { TableRenderer } from "./TableRenderer";
import { ChartRenderer } from "./ChartRender";

// Вынести в отдельный файл utils/fonts.js
const FONT_WEIGHTS = [
  { weight: 100, name: "Thin" },
  { weight: 200, name: "ExtraLight" },
  { weight: 300, name: "Light" },
  { weight: 400, name: "Regular" },
  { weight: 500, name: "Medium" },
  { weight: 600, name: "SemiBold" },
  { weight: 700, name: "Bold" },
  { weight: 800, name: "ExtraBold" },
  { weight: 900, name: "Black" },
];

// Регистрация шрифтов для PDF
Font.register({
  family: "Inter",
  fonts: FONT_WEIGHTS.flatMap(({ weight, name }) => [
    {
      src: `/pdfFonts/Inter-${name}.ttf`,
      fontStyle: "normal",
      fontWeight: weight,
    },
    {
      src: `/pdfFonts/Inter-${name}Italic.ttf`,
      fontStyle: "italic",
      fontWeight: weight,
    },
  ]),
});

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    color: "#303030",
    fontFamily: "Inter",
    fontSize: 9,
    padding: "30px 55px 30px",
  },

  anchor: {
    position: "absolute",
    top: 0,
    left: 0,
  },

  h1: {
    fontSize: 18,
    lineHeight: 1.4,
    fontWeight: 600,
    marginBottom: 15,
  },

  textBlock: {
    lineHeight: 1,
    marginBottom: 10,
  },
  tableBlock: {
    marginBottom: 10,
  },
  chartBlock: {
    marginBottom: 10,
  },
});

const PDF = ({ data, title }) => {
  return (
    <Document title={title}>
      <Page size="A4" dpi={72} style={styles.page}>
        <Text style={styles.h1}>{title}</Text>

        {data.map((section, idx) => {
          switch (section.type) {
            case "text":
              return (
                <HTMLRenderer
                  key={idx}
                  html={section.text}
                  style={styles.textBlock}
                />
              );
            case "table":
              return (
                <TableRenderer
                  key={idx}
                  columns={section.columns}
                  rows={section.rows}
                  sum={section.sum}
                  style={styles.tableBlock}
                />
              );
            case "chart":
              return (
                <ChartRenderer
                  key={idx}
                  title={section.title}
                  screenshot={section.screenshot}
                  style={styles.chartBlock}
                />
              );

            default:
              return null;
          }
        })}
      </Page>
    </Document>
  );
};
export default PDF;
